export default __webpack_public_path__ + "static/dagny-e52cebd8adeac93d86dca0cb4108f37a.svg";